import { render, staticRenderFns } from "./RegistrationChecklistItemsList.vue?vue&type=template&id=0cb5e18e&scoped=true"
import script from "./RegistrationChecklistItemsList.vue?vue&type=script&lang=js"
export * from "./RegistrationChecklistItemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb5e18e",
  null
  
)

export default component.exports